import React from 'react';

import PropTypes from 'prop-types';
import JoinForm from './JoinForm';

export const Pricing = ({
  openModal,
  openModalToggle,
  setFormSubmitted,
  step,
  formSubmitted,
  isMobile,
}) => (
  <div id="demo-modal" className={openModal ? 'show-modal' : ''}>
    <div className="modal">
      <button
        type="button"
        className="button-unstyled button-close"
        onClick={openModalToggle}>
        <img src="/img/close.svg" alt="close" />
      </button>
      <JoinForm
        setFormSubmitted={setFormSubmitted}
        step={step}
        formSubmitted={formSubmitted}
        isMobile={isMobile}
      />
      <div className={`thanks-form ${formSubmitted ? 'show' : ''}`}>
        <div>
          <img src="/img/thanks-form.svg" alt="" />
          <h4>
            Thank you for joining our waitlist!
            <br /> We’ll get back to you with exciting news.
          </h4>
          <a href="/" className="button button-green">
            Go to Homepage
          </a>
        </div>
        <p>
          For any queries or issues, please reach out to us at{' '}
          <a href="mailto:hello@cliphire.co">hello@cliphire.co</a> We’d love to
          help you :)
        </p>
      </div>
    </div>
  </div>
);

Pricing.propTypes = {
  openModal: PropTypes.bool.isRequired,
  step: PropTypes.number.isRequired,
  openModalToggle: PropTypes.func.isRequired,
  setFormSubmitted: PropTypes.func.isRequired,
  formSubmitted: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default Pricing;
